// import React, { useState } from 'react';
// import {
//     Drawer,
//     Typography,
//     Button,
//     Box,
//     IconButton,
//     Divider,
//     Input,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';

// const ImportUsersPopup = ({ open, onClose, onImport }) => {
//     const [selectedFile, setSelectedFile] = useState(null);

//     const handleFileUpload = (event) => {
//         const file = event.target.files[0];
//         setSelectedFile(file);
//     };

//     const handleImport = () => {
//         if (onImport && selectedFile) {
//             onImport(selectedFile);
//         }
//         onClose();
//     };

//     return (
//         <Drawer
//             anchor="right"
//             open={open}
//             onClose={onClose}
//             PaperProps={{
//                 sx: { width: '450px' },
//             }}
//         >
//             {/* Header */}
//             <Box
//                 sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'space-between',
//                     padding: '16px',
//                     borderBottom: '1px solid #e0e0e0',
//                 }}
//             >
//                 <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//                     Import Users
//                 </Typography>
//                 <Button
//                     onClick={onClose}
//                     style={{
//                         position: 'absolute',
//                         top: '-10px',
//                         left: '-50px',
//                         backgroundColor: '#fff',
//                         borderRadius: '50%',
//                         boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//                         minWidth: '40px',
//                         height: '40px',
//                         padding: '8px',
//                         zIndex: 1,
//                     }}
//                 >
//                     <CloseIcon />
//                 </Button>
//             </Box>

//             {/* Content */}
//             <Box sx={{ padding: '16px' }}>
//                 {/* SSO Section */}
//                 <Typography variant="subtitle1" sx={{ marginBottom: '16px' }}>
//                     Connect via SSO
//                 </Typography>
//                 <Box sx={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
//                     <Button
//                         variant="outlined"
//                         startIcon={<img src="https://img.icons8.com/color/48/000000/google-logo.png" alt="Google" style={{ width: 20, height: 20 }} />}
//                     >
//                         Continue with Google
//                     </Button>
//                     <Button
//                         variant="outlined"
//                         startIcon={<img src="https://img.icons8.com/color/48/000000/microsoft.png" alt="Microsoft" style={{ width: 20, height: 20 }} />}
//                     >
//                         Continue with Microsoft
//                     </Button>
//                 </Box>

//                 <Divider sx={{ marginBottom: '24px' }} />

//                 {/* CSV Upload Section */}
//                 <Typography variant="subtitle1" sx={{ marginBottom: '16px' }}>
//                     Add CSV
//                 </Typography>
//                 <Box
//                     sx={{
//                         border: '2px dashed #9e9e9e',
//                         borderRadius: '8px',
//                         padding: '16px',
//                         textAlign: 'center',
//                         marginBottom: '24px',
//                     }}
//                 >
//                     <CloudUploadOutlinedIcon sx={{ fontSize: '48px', color: '#9e9e9e', marginBottom: '8px' }} />
//                     <Typography variant="body2" sx={{ marginBottom: '8px' }}>
//                         Drag & Drop CSV
//                     </Typography>
//                     <Typography variant="body2" sx={{ marginBottom: '8px', color: '#757575' }}>
//                         or
//                     </Typography>
//                     <Typography
//                         variant="contained"
//                         component="label"
//                         sx={{
//                             color: '#ff0083'
//                         }}
//                         onChange={handleFileUpload}

//                     >
//                         add file

//                     </Typography>
//                 </Box>

//                 {/* Show selected file */}
//                 {selectedFile && (
//                     <Typography
//                         variant="body2"
//                         sx={{ marginBottom: '24px', color: '#4caf50' }}
//                     >
//                         Selected File: {selectedFile.name}
//                     </Typography>
//                 )}
//             </Box>

//             {/* Footer */}
//             <Box
//                 sx={{
//                     padding: '16px',
//                     display: 'flex',
//                     justifyContent: 'flex-end',
//                     borderTop: '1px solid #e0e0e0',
//                 }}
//             >
//                 <Button
//                     variant="contained"
//                     onClick={handleImport}
//                     disabled={!selectedFile}
//                     sx={{
//                         backgroundColor: '#ff0083',
//                         color: 'white',
//                         '&:hover': {
//                             backgroundColor: '#e00074',
//                         },
//                     }}
//                 >
//                     Import
//                 </Button>
//             </Box>
//         </Drawer>
//     );
// };

// export default ImportUsersPopup;
import React, { useState } from 'react';
import {
  Drawer,
  Typography,
  Button,
  Box,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import './AddUserPopup.css'; // Reuse the same styles

const ImportUsersPopup = ({ open, onClose, onImport }) => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleImport = () => {
    if (onImport && selectedFile) {
      onImport(selectedFile);
    }
    onClose();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: '500px' },
        style: { overflow: 'visible', margin: '10px 10px 10px' },
      }}
    >
      {/* Header */}
      <div className="drawer-header-user" style={{ padding: '16px', position: 'relative' }}>
        <Typography
          style={{
            fontFamily: 'Barlow Condensed',
            fontWeight: 500,
            fontSize: '24px',
          }}
          variant="h5"
        >
          Import Users
        </Typography>
        <Button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '-1px',
            left: '-50px',
            backgroundColor: '#fff',
            borderRadius: '50%',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            minWidth: '40px',
            height: '40px',
            padding: '8px',
            zIndex: 1,
          }}
        >
          <CloseIcon style={{ color: 'black' }} />
        </Button>
      </div>

      {/* Content */}
      <div style={{ padding: '16px' }}>
        {/* SSO Section */}
        <Typography variant="subtitle1" sx={{ marginBottom: '16px' }}>
          Connect via SSO
        </Typography>
        <Box sx={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
          <Button
            variant="outlined"
            startIcon={
              <img
                src="https://img.icons8.com/color/48/000000/google-logo.png"
                alt="Google"
                style={{ width: 20, height: 20 }}
              />
            }
          >
            Continue with Google
          </Button>
          <Button
            variant="outlined"
            startIcon={
              <img
                src="https://img.icons8.com/color/48/000000/microsoft.png"
                alt="Microsoft"
                style={{ width: 20, height: 20 }}
              />
            }
          >
            Continue with Microsoft
          </Button>
        </Box>

        <Divider sx={{ marginBottom: '24px' }} />

        {/* CSV Upload Section */}
        <Typography variant="subtitle1" sx={{ marginBottom: '16px' }}>
          Add CSV
        </Typography>
        <Box
          sx={{
            border: '2px dashed #9e9e9e',
            borderRadius: '8px',
            padding: '16px',
            textAlign: 'center',
            marginBottom: '24px',
          }}
        >
          <CloudUploadOutlinedIcon sx={{ fontSize: '48px', color: '#9e9e9e', marginBottom: '8px' }} />
          <Typography variant="body2" sx={{ marginBottom: '8px' }}>
            Drag & Drop CSV
          </Typography>
          <Typography variant="body2" sx={{ marginBottom: '8px', color: '#757575' }}>
            or
          </Typography>
          <label
            htmlFor="file-upload"
            style={{ color: '#ff0083', cursor: 'pointer' }}
          >
            add file
          </label>
          <input
            id="file-upload"
            type="file"
            style={{ display: 'none' }}
            accept=".csv"
            onChange={handleFileUpload}
          />
        </Box>

        {/* Show selected file */}
        {selectedFile && (
          <Typography
            variant="body2"
            sx={{ marginBottom: '24px', color: '#4caf50' }}
          >
            Selected File: {selectedFile.name}
          </Typography>
        )}
      </div>

      {/* Footer */}
      <div
        style={{
          position: 'absolute',
          bottom: '0',
          right: '0',
          width: '100%',
          padding: '16px',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          style={{ backgroundColor: '#ff0083', color: 'white', marginRight: '8px' }}
          onClick={handleImport}
          disabled={!selectedFile}
        >
          Import
        </Button>
      </div>
    </Drawer>
  );
};

export default ImportUsersPopup;
